import { axiosInstance } from '../common/api';

export const resetPassword = (token, data) => {
  const config = {
    headers: { token }
  }
  const url = `/auth/resetpassword/${token}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
